import jwtDecode from 'jwt-decode';

export const isLogin = (): boolean => {
  const authToken = localStorage.getItem("charisma-token");
  return (authToken && authToken !== "") || false;
};

export const saveToken = (token: string): void => {
  localStorage.setItem("charisma-token", token);
};

export const deleteToken = (): void => {
  localStorage.removeItem("charisma-token");
};

export const logout = (): void => {
  deleteToken();
  window.location.replace("/login");
};

export const tokenAction = (token: string) => {
  const decoded: any = jwtDecode(token);
  return decoded.action;
};
